import update from "immutability-helper";
import * as React from "react";
import { FormControl, ListGroupItem, Panel } from "react-bootstrap";
import { ComponentEx } from "../../../controls/ComponentEx";
import Toggle from "../../../controls/Toggle";
import { Button } from "../../../controls/TooltipControls";
import { getSafe, setSafe } from "../../../util/storeHelper";
const MIN_PROFILE_NAME_LENGTH = 3;
const MAX_PROFILE_NAME_LENGTH = 64;
/**
 * list element displayed when editing an item
 *
 * @class ProfileEdit
 */
class ProfileEdit extends ComponentEx {
    constructor(props) {
        super(props);
        const features = props.features.filter((feature) => feature.supported());
        this.state =
            props.profile !== undefined
                ? {
                    edit: { ...props.profile },
                    features,
                }
                : {
                    edit: {
                        id: props.profileId,
                        gameId: props.gameId,
                        modState: {},
                        name: "",
                        lastActivated: 0,
                    },
                    features,
                };
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        if (this.props.gameId !== newProps.gameId) {
            this.setState(update(this.state, {
                features: {
                    $set: newProps.features.filter((feature) => feature.supported()),
                },
            }));
        }
    }
    render() {
        const { t, onCancelEdit, profile, profileId } = this.props;
        const { edit, features } = this.state;
        const nameValid = edit.name.trim().length >= MIN_PROFILE_NAME_LENGTH;
        const inputControl = (React.createElement(FormControl, { autoFocus: true, style: { flexGrow: 1 }, type: "text", value: edit.name, maxLength: MAX_PROFILE_NAME_LENGTH, onChange: this.changeEditName, onKeyPress: this.handleKeypress }));
        return (React.createElement(Panel, { className: "profile-edit-panel" },
            React.createElement(Panel.Body, null,
                profile === undefined
                    ? t("Create a new profile")
                    : t("Edit profile"),
                React.createElement(ListGroupItem, { key: profileId },
                    React.createElement("div", { className: "inline-form" },
                        inputControl,
                        React.createElement(Button, { bsStyle: "primary", disabled: !nameValid, id: "__accept", tooltip: nameValid ? t("Accept") : t("Profile name must be at least {{num}} characters", { num: MIN_PROFILE_NAME_LENGTH }), onClick: this.saveEdit }, t("Save")),
                        React.createElement(Button, { bsStyle: "secondary", id: "__cancel", tooltip: t("Cancel"), onClick: onCancelEdit }, t("Cancel"))),
                    React.createElement("div", null, features.map(this.renderFeature))))));
    }
    renderFeature = (feature) => {
        const { t } = this.props;
        const { edit } = this.state;
        if (feature.type === "boolean") {
            return (React.createElement(Toggle, { checked: getSafe(edit, ["features", feature.id], false), dataId: feature.id, key: feature.id, onToggle: this.toggleCheckbox }, t(feature.description)));
        }
        else if (feature.type === "text") {
            return (React.createElement(FormControl, { componentClass: "textarea", "data-id": feature.id, key: feature.id, placeholder: t(feature.description), value: getSafe(edit, ["features", feature.id], undefined) ?? "", onChange: this.assignString }));
        }
    };
    toggleCheckbox = (ticked, dataId) => {
        this.setState(setSafe(this.state, ["edit", "features", dataId], ticked));
    };
    assignString = (evt) => {
        const dataId = evt.currentTarget.getAttribute("data-id");
        const value = evt.currentTarget.value;
        this.setState(setSafe(this.state, ["edit", "features", dataId], value));
    };
    handleKeypress = (evt) => {
        if (evt.key === "Enter") {
            evt.preventDefault();
            if (this.state.edit.name.trim().length >= MIN_PROFILE_NAME_LENGTH) {
                this.saveEdit();
            }
        }
    };
    saveEdit = () => {
        this.props.onSaveEdit(this.state.edit);
    };
    changeEditName = (evt) => {
        this.setState(update(this.state, {
            edit: {
                name: { $set: evt.target.value },
            },
        }));
    };
}
export default ProfileEdit;
